(ns ui.layout
  (:require [ui.util :as uu]))

(defn sidebar-main
  [{:keys [min-w max-w class]
    :or   {min-w "320px"
           max-w "480px"}
    :as   _props} sidebar main]
  [:div
   {:class (uu/cm
            ;; base: mobile stack, full width children
            "flex flex-col w-full items-start"
            ;; non-mobile for all sizes
            "@sm:grid @md:items-stretch @md:min-h-0 @md:h-full @sm:content-start"
            ;; medium 50-50
            "@md:content-stretch @md:[grid-template-columns:minmax(var(--sb-min),_var(--sb-max))_1fr]"
            ;; large
            "@lg:[grid-template-columns:minmax(var(--sb-min),_var(--sb-max))_1fr]"
            ;; container ≥ 1441px → 3-track (right track = fluid margin)
            (str "@xwide:[grid-template-columns:minmax(var(--sb-min),_var(--sb-max))_960px_1fr]")
            ;; optional cap inside the container at xwide
            "@xwide:max-w-[1920px]"
            class)
    :style {"--sb-min" min-w
            "--sb-max" max-w}}
   sidebar
   main])

(defn inline-container
  [& children]
  (into [:div {:class "[container-type:inline-size] flex flex-row flex-auto"}]
        children))

(defn right-align
  [& children]
  (into [:div
         {:class "flex-1 flex flex-row gap-2 justify-end"}]
        (remove nil? children)))

(defn left-align
  [& children]
  (into [:div
         {:class "flex flex-row gap-2 justify-start"}]
        (remove nil? children)))

(defn row
  [& children]
  (into [:div
         {:class "flex-0 flex flex-row gap-1"}]
        (remove nil? children)))
